import { render, staticRenderFns } from "./MergingAccounts.vue?vue&type=template&id=3364f7b4&scoped=true&"
import script from "./MergingAccounts.vue?vue&type=script&lang=ts&"
export * from "./MergingAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./MergingAccounts.vue?vue&type=style&index=0&id=3364f7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364f7b4",
  null
  
)

export default component.exports